import { createLoadingReducer } from './utils';

export default createLoadingReducer('ZESEC_SETTINGS');
